const OFFSET = 90; // altura do header fixo + margem

function smoothScroll(hash: string): void {
    const target = document.querySelector(hash) as HTMLElement | null;
    if (!target) return;
    const y = target.getBoundingClientRect().top + window.scrollY - OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
}

document.addEventListener('click', (e) => {
    const a = (e.target as HTMLElement).closest('a[href]');
    if (!a) return;

    const href = a.getAttribute('href') ?? '';

    // Caso 1: link puramente de âncora — #section
    if (href.startsWith('#') && href.length > 1) {
        const target = document.querySelector(href);
        if (target) {
            e.preventDefault();
            history.pushState(null, '', href);
            smoothScroll(href);
        }
        return;
    }

    // Caso 2: URL completa com hash da mesma origem (ex: http://site.com/#resultados)
    try {
        const url = new URL(href);
        if (
            url.hash.length > 1 &&
            url.origin === location.origin &&
            (url.pathname === '/' || url.pathname === location.pathname)
        ) {
            const target = document.querySelector(url.hash);
            if (target) {
                e.preventDefault();
                history.pushState(null, '', url.hash);
                smoothScroll(url.hash);
            }
            // Se o elemento não existe na página atual, deixa o browser navegar normalmente
        }
    } catch {
        // URL inválida ou relativa — ignora
    }
});

// Ao chegar de outra página com hash na URL
window.addEventListener('load', () => {
    if (location.hash && location.hash.length > 1) {
        setTimeout(() => smoothScroll(location.hash), 200);
    }
});
